module.exports = __webpack_public_path__ + "img/contact_QQ.09f1ac01.png";